import React, { useState } from 'react';
import {Input} from '../FormFields';
import Button from '../Button/Button';
import { navigate } from 'gatsby';
import { withTranslation } from 'react-i18next';

const SearchCard = ({ t, title }) => {
  const [searchValue, setSearchValue] = useState('');
  const [validationMessage, setValidationMessage] = useState('');
  const onBlur = (e) => {
    setValidationMessage('');
  }
  const onChange = (e) => {
    setSearchValue(e.target.value);
    validate(e.target.value);
  }
  const onSubmit = (e) => {
    e.preventDefault();
    if (validate(searchValue)) {
      navigate(`${t('search.url')}?term=${searchValue}`);
    }
  }
  const validate = (input) => {
    if (input.length === 0){
      setValidationMessage(t('search_card.validation_message'));
      return false;
    } else {
      setValidationMessage('');
      return true;
    }
  }

  if (!title) {
    title = t("search_card.input_label")
  }

  return (
    <div className="card orange search-card">
      <form action={t('search.url')} className="search-form" onSubmit={onSubmit}>
        <Input
          type="text"
          label={title}
          placeholder={t("search_card.input_placeholder")}
          onBlur={(e)=>onBlur(e)}
          onChange={(e)=>onChange(e)}
          value={searchValue}
          validationMessage={validationMessage}
        />
        <Button type="submit">{t('search_card.button')}</Button>
      </form>
    </div>
  )
}

export default withTranslation()(SearchCard);
